import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-maintenance-royal-decree",
  templateUrl: "./maintenance-royal-decree.component.html",
  styleUrls: ["./maintenance-royal-decree.component.sass"],
})
export class MaintenanceRoyalDecreeComponent {}
